import React, { useEffect, useState } from 'react';
import './styles';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import UIController from '../../../../../components/UI/UIController';
import Helmet from 'react-helmet';
import UILoadingPage from '../../../../../components/UI/UILoadingPage/UILoadingPage';
import { ADMIN_TASK_TABS, TABS } from './config';
import Queries from '../../../../../utils/API/Queries';
import { useHistory, useLocation } from 'react-router-dom';
import { useLazyQuery } from 'react-apollo';
import { SERVICES_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import * as strings from './strings';
import { GET_ADMIN_TASKS_SERVICES } from './queries';
import UITabBar from '../../../../../components/UI/UITabBar';

export default function AdminTasks({}: AdminTasksProps) {
	const history = useHistory();
	const location = useLocation();

	const [selectedTab, setSelectedTab] = useState<PLTab>();

	const [tabData, setTabData] = useState<object>({});

	const setTabIfFirst = (newTabData) => {
		const newSelectedTab = getTabs(newTabData)[0];
		if (!selectedTab && newSelectedTab) {
			setSelectedTab(newSelectedTab);
		}
	};

	const getTabs = (tabAggregateData) => {
		const tabs = TABS().filter((tab) => tabAggregateData[tab.value]?.length > 0);
		return tabs || [];
	};

	const addToTabData = (tab: AdminTaskTabType, queryData) => {
		if (queryData) {
			const newTabData = { ...tabData, [tab.value]: queryData[tab.tableType === SERVICES_TABLE_TYPE ? 'services' : 'serviceRequests'] };
			setTabData(newTabData);
			setTabIfFirst(newTabData);
		}
	};

	const [getAdditionalProcessingRequiredServices, { data: additionalProcessingRequiredData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.additionalProcessingRequired.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.additionalProcessingRequired, additionalProcessingRequiredData);
		})();
	}, [additionalProcessingRequiredData]);

	const [getAdminHoldServices, { data: adminHoldServicesData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.administrativeHold.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.administrativeHold, adminHoldServicesData);
		})();
	}, [adminHoldServicesData]);

	const [getAwaitingApprovalServices, { data: awaitingApprovalData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.awaitingApproval.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.awaitingApproval, awaitingApprovalData);
		})();
	}, [awaitingApprovalData]);

	const [getClaimedServices, { data: claimedServicesData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.claimedServices.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.claimedServices, claimedServicesData);
		})();
	}, [claimedServicesData]);

	const [getIncompleteFloorPlansServices, { data: incompleteFloorPlansData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.incompleteFloorPlans.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.incompleteFloorPlans, incompleteFloorPlansData);
		})();
	}, [incompleteFloorPlansData]);

	const [getIncompleteMatterportsServices, { data: incompleteMatterportsData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.incompleteMatterports.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.incompleteMatterports, incompleteMatterportsData);
		})();
	}, [incompleteMatterportsData]);

	const [getLateEditorUploadServices, { data: lateEditorUploadData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.lateEditorUpload.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.lateEditorUpload, lateEditorUploadData);
		})();
	}, [lateEditorUploadData]);

	const [getPendingInitialApprovalServices, { data: pendingInitialApprovalData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.pendingInitialApproval.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.pendingInitialApproval, pendingInitialApprovalData);
		})();
	}, [pendingInitialApprovalData]);

	const [getSchedulingNeededServices, { data: schedulingNeededData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.schedulingNeeded.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.schedulingNeeded, schedulingNeededData);
		})();
	}, [schedulingNeededData]);

	const [getSchedulingPreferredTechnicianServices, { data: schedulingPreferredTechnicianData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.schedulingPreferredTechnician.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.schedulingPreferredTechnician, schedulingPreferredTechnicianData);
		})();
	}, [schedulingPreferredTechnicianData]);

	const [getServicesAwaitingEditorAcceptanceServices, { data: servicesAwaitingEditorAcceptanceData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.servicesAwaitingEditorAcceptance.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.servicesAwaitingEditorAcceptance, servicesAwaitingEditorAcceptanceData);
		})();
	}, [servicesAwaitingEditorAcceptanceData]);

	const [getUpcomingWithoutTechnicianServices, { data: upcomingWithoutTechnicianData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.upcomingWithoutTechnician.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.upcomingWithoutTechnician, upcomingWithoutTechnicianData);
		})();
	}, [upcomingWithoutTechnicianData]);

	const [getUploadNeededServices, { data: uploadNeededData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.uploadNeeded.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.uploadNeeded, uploadNeededData);
		})();
	}, [uploadNeededData]);

	const [getWaitingForCompletionServices, { data: waitingForCompletionData }] = useLazyQuery(GET_ADMIN_TASKS_SERVICES, {
		variables: { q: ADMIN_TASK_TABS.waitingForCompletion.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.waitingForCompletion, waitingForCompletionData);
		})();
	}, [waitingForCompletionData]);

	const [getServiceRequestsAwaitingTechnicianAcceptance, { data: serviceRequestsAwaitingTechnicianAcceptanceData }] = useLazyQuery(Queries.GET_SERVICE_REQUESTS, {
		variables: { query: ADMIN_TASK_TABS.serviceRequestsAwaitingTechnicianAcceptance.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.serviceRequestsAwaitingTechnicianAcceptance, serviceRequestsAwaitingTechnicianAcceptanceData);
		})();
	}, [serviceRequestsAwaitingTechnicianAcceptanceData]);

	const [getServiceRequestsAwaitingRequestApproval, { data: serviceRequestsAwaitingRequestApprovalData }] = useLazyQuery(Queries.GET_SERVICE_REQUESTS, {
		variables: { query: ADMIN_TASK_TABS.serviceRequestsAwaitingRequestApproval.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.serviceRequestsAwaitingRequestApproval, serviceRequestsAwaitingRequestApprovalData);
		})();
	}, [serviceRequestsAwaitingRequestApprovalData]);

	const [getServiceRequestsAwaitingReview, { data: serviceRequestsAwaitingReviewData }] = useLazyQuery(Queries.GET_SERVICE_REQUESTS, {
		variables: { query: ADMIN_TASK_TABS.serviceRequestsAwaitingReview.query }
	});
	useEffect(() => {
		(() => {
			addToTabData(ADMIN_TASK_TABS.serviceRequestsAwaitingReview, serviceRequestsAwaitingReviewData);
		})();
	}, [serviceRequestsAwaitingReviewData]);

	const queryForTab = (tab) => {
		switch (tab?.value) {
			case ADMIN_TASK_TABS.additionalProcessingRequired.value:
				getAdditionalProcessingRequiredServices();
				break;
			case ADMIN_TASK_TABS.administrativeHold.value:
				getAdminHoldServices();
				break;
			case ADMIN_TASK_TABS.awaitingApproval.value:
				getAwaitingApprovalServices();
				break;
			case ADMIN_TASK_TABS.claimedServices.value:
				getClaimedServices();
				break;
			case ADMIN_TASK_TABS.incompleteFloorPlans.value:
				getIncompleteFloorPlansServices();
				break;
			case ADMIN_TASK_TABS.incompleteMatterports.value:
				getIncompleteMatterportsServices();
				break;
			case ADMIN_TASK_TABS.lateEditorUpload.value:
				getLateEditorUploadServices();
				break;
			case ADMIN_TASK_TABS.pendingInitialApproval.value:
				getPendingInitialApprovalServices();
				break;
			case ADMIN_TASK_TABS.schedulingNeeded.value:
				getSchedulingNeededServices();
				break;
			case ADMIN_TASK_TABS.schedulingPreferredTechnician.value:
				getSchedulingPreferredTechnicianServices();
				break;
			case ADMIN_TASK_TABS.servicesAwaitingEditorAcceptance.value:
				getServicesAwaitingEditorAcceptanceServices();
				break;
			case ADMIN_TASK_TABS.serviceRequestsAwaitingTechnicianAcceptance.value:
				getServiceRequestsAwaitingTechnicianAcceptance();
				break;
			case ADMIN_TASK_TABS.serviceRequestsAwaitingRequestApproval.value:
				getServiceRequestsAwaitingRequestApproval();
				break;
			case ADMIN_TASK_TABS.serviceRequestsAwaitingReview.value:
				getServiceRequestsAwaitingReview();
				break;
			case ADMIN_TASK_TABS.upcomingWithoutTechnician.value:
				getUpcomingWithoutTechnicianServices();
				break;
			case ADMIN_TASK_TABS.uploadNeeded.value:
				getUploadNeededServices();
				break;
			case ADMIN_TASK_TABS.waitingForCompletion.value:
				getWaitingForCompletionServices();
				break;
			default:
				break;
		}
	};

	const queryAll = async () => {
		for (let tab of TABS()) {
			queryForTab(tab);
		}
	};

	useEffect(() => {
		(async () => {
			await queryAll();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			queryForTab(selectedTab);
		})();
	}, [location.search]);

	const renderSelectedTab = () => {
		if (!selectedTab && getIsLoading()) return <UILoadingPage />;
		return (
			<PLTable
				type={selectedTab?.tableType ?? SERVICES_TABLE_TYPE}
				updateTable={() => {}}
				limit={20}
				emptySetText={strings.emptySetText}
				data={tabData[selectedTab?.value ?? '']}
				onSelect={(item) => history.push(selectedTab?.linkPath + item.id)}
			/>
		);
	};

	const updateSelectedTab = (updatedTab) => {
		if (!selectedTab) return;
		setSelectedTab(updatedTab);
	};

	const renderTabComponent = () => {
		if (!selectedTab) {
			return;
		}

		return (
			<div className='adminTasks--pin'>
				<UITabBar containerClassName='adminTasks--tabs' selectedTab={selectedTab} updateSelected={updateSelectedTab} tabs={getTabs(tabData)} />
			</div>
		);
	};

	const getIsLoading = () => !selectedTab && Object.keys(tabData).length === 0;

	const renderContent = () => {
		if (getIsLoading()) {
			return <UILoadingPage />;
		}

		return (
			<>
				<Helmet>
					<title>Admin Tasks | Pineapple Labs</title>
					<meta property='og:title' content={strings.pageTitle} />
				</Helmet>
				{renderTabComponent()}
				{renderSelectedTab()}
			</>
		);
	};

	return <UIController bodyClassName='adminTasks--body'>{renderContent()}</UIController>;
}
